import { render, staticRenderFns } from "./addDImodel.vue?vue&type=template&id=6d94a618&scoped=true"
import script from "./addDImodel.vue?vue&type=script&lang=js"
export * from "./addDImodel.vue?vue&type=script&lang=js"
import style0 from "./addDImodel.vue?vue&type=style&index=0&id=6d94a618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94a618",
  null
  
)

export default component.exports